<template>
  <div class="field-label d-flex align-center text-textLighter">
    <div class="text">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldLabel',
};
</script>

<style lang="less" scoped>
.field-label {
  user-select: none;
  font-size: 8px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
